import React, { useEffect, useState } from 'react'
import { Button, Container, Modal } from 'react-bootstrap'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import { useSelector } from 'react-redux';
import ExportBox from "../components/ExportBox/ExportBox"
import Table from "../components/Table/Table"
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import CustomModel from '../components/CustomModel/CustomModel';
import FeesModel from '../components/FeesModel/FeesModel';
import Paginations from './Paginations';

function Maintenance() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [items, setItems] = useState([])
  const userinfo = useSelector((state) => state);
  const [totalPrice, setTotalPrice] = useState(0);
  const [imageSrc, setImgSrc] = useState(false);
  const [showImg, setShowImg] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]); // مصفوفة الـ IDs المحددة
  const [selectAll, setSelectAll] = useState(false);   // حالة تحديد الكل
  const [searchText, setSearchText] = useState("");

  const navigate = useNavigate();
  const [is_registration_fee, setIs_registration_fee] = useState(null);
  const [modalShowFees, setModalShowFees] = React.useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [feesId, setFeesId] = React.useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationsItems, setPaginationsItems] = useState(null)

  const [statusPending, setstatusPending] = useState(false);
  const [acceotRejectId, setAcceotRejectId] = useState('')
  const handleToggle = (item) => {
    if (item.status == "accepted") return;

    setSelectedIds((prev) =>
      prev.includes(item.id)
        ? prev.filter((i) => i !== item.id)
        : [...prev, item.id]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedIds([]);
    } else {
      const pendingIds = items
        .filter(item => item.status !== "accepted")
        .map(item => item.id);

      setSelectedIds(pendingIds);
    }
    setSelectAll(!selectAll);
  };
  const headerIterm = [
    currentLocal.home.ID,
    currentLocal.home.image,
    currentLocal.home.description,
    currentLocal.home.price,
    currentLocal.home.date,
    localStorage.getItem("type") !== "maintenance" && currentLocal.home.employee,
    localStorage.getItem("type") !== "maintenance" && currentLocal.home.phone,
    localStorage.getItem("type") !== "maintenance" && currentLocal.home.role,
    currentLocal.home.status,
    localStorage.getItem("type") !== "maintenance" && currentLocal.home.actions,
  ].filter(Boolean); // هنا بيتشال أي قيمة فاضية

  const header = <thead>
    <tr>
      {localStorage.getItem("type") != "maintenance" &&
        <th>
          <input
            type="checkbox"
            checked={selectAll}
            onChange={handleSelectAll}
          />
        </th>
      }
      {headerIterm.map((item, index) => (
        <th key={index}>{item}</th>
      ))}
    </tr>
  </thead>


  const handleShowImg = (img) => {
    setShowImg(true)
    setImgSrc(img)
  }
  const filteredItems = items.filter((item) => {
    const search = searchText.toLowerCase();

    const name = item.employee?.name?.toLowerCase() || "";
    const phone = item.employee?.phone?.toLowerCase() || "";
    const date = item.date?.toLowerCase() || "";

    // permissions (roles)
    // const roles = item?.roles
    //   ?.map((r) =>
    //     r?.id == 26 ? item?.job_title : r?.name
    //   )
    //   .join(" ")
    //   .toLowerCase() || "";

    return (
      name.includes(search) ||
      phone.includes(search) ||
      date.includes(search)
    );
  });
  useEffect(() => {
    const getAllApis = async () => {
      const endPoint = localStorage.getItem("type") !== "maintenance" ?
        `https://nanosoft.space/taarteb/public/api/admin/maintenances?paginated=10&page=${currentPage}`
        :
        `https://nanosoft.space/taarteb/public/api/my-maintenances?paginated=10&page=${currentPage}`
      await axios
        .get(endPoint, {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,

          }
        })
        .then(async (res) => {

          setPaginationsItems(localStorage.getItem("type") == "maintenance" ?res.data.data:res.data.data.data)
          const fetchedItems = localStorage.getItem("type") == "maintenance" ? res.data.data.data : res.data.data.data.data;
          setItems(fetchedItems);

          // Calculate total
          const total = fetchedItems.reduce((sum, item) => {
            // ensure price is a number
            return sum + (parseFloat(item.price) || 0);
          }, 0);

          setTotalPrice(total);





        })
        .catch((error) => {





        });

    }
    getAllApis()

  }, [currentPage])
  const body = <tbody>
    {filteredItems?.map((item, index) => {
      console.log(filteredItems);

      return (
        <tr key={index}>
          {localStorage.getItem("type") != "maintenance" &&

            <td>
              {item.status != "accepted" &&
                <input
                  type="checkbox"
                  checked={selectedIds.includes(item.id)}
                  onChange={() => handleToggle(item)}
                />

                // <input
                //   type="checkbox"
                //   checked={selectedIds.includes(item.id)}
                //   onChange={() => handleToggle(item.id)}
                // />
              }
            </td>

          }
          <td>
            {item?.id}
          </td>
          <td style={{ width: "10%", }}
            onClick={() => handleShowImg(item?.image)}

          >

            <img src={item.image} alt="" className='w-100' />
          </td>

          <td>
            {item?.description}
          </td>
          <td>
            {item?.price}{" "}{currentLocal.home.currancy}
          </td>
          <td>
            {item?.date}
          </td>
          {localStorage.getItem("type") !== "maintenance" &&
            <td>
              {item.employee?.name ? item.employee?.name : item.employee}
            </td>
          }
          {localStorage.getItem("type") !== "maintenance" &&
            <td>
              {item.employee?.phone ? item.employee?.phone : item.employee}
            </td>
          }

          {localStorage.getItem("type") !== "maintenance" &&
            <td>
              {item.employee?.role ? item.employee?.role : item.employee}
            </td>
          }

          <td>{item.status == "accepted" ? currentLocal.home.accept : item.status == "pending" ? currentLocal.home.pending : currentLocal.home.reject}
            <p>{item?.reason}</p>

            <p>
              {item.status == "rejected" && item?.reject_reason && item?.reject_reason}
              {item.status == "rejected" && item?.rejected_reason && item?.rejected_reason}
            </p>
          </td>
          {/* {localStorage.getItem("type") !== "maintenance" ?
                  item.status === "rejected" ? (
                    <td
                      className={'pament bg-success'}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        setFeesId(item?.id)
                        setModalShowFees(true)
                      }}
                    >
                      {currentLocal.home.rePay}
                    </td>
                  ):(
                                    <td >

                                    <div className='d-flex'>
                                      <Button className='mx-3'
                                        onClick={() => {
                                          setModalShow(true);
                                          setAcceotRejectId(item?.id)
          
                                          setstatusPending('accept')
                                          setIs_registration_fee(item?.is_registration_fee)
          
                                        }}
                                      >{currentLocal.home.accept}</Button>
                                      <Button variant="danger" onClick={() => {
                                        setModalShow(true);
                                        setAcceotRejectId(item?.id)
                                        setstatusPending('reject')
                                      }}>{currentLocal.home.reject}</Button>
                                    </div>
                                    </td>
                  )
                                    
      

                                  :
                                  <td >
                        <div className="form-check" onClick={() => {
                          navigate(`/dashboard/maintenances/edite/${item?.id}`)
                        }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                          </svg>
                        </div>


                      </td>
    } */}
          <td>
            {localStorage.getItem("type") !== "maintenance" ?
              <div className="d-flex">

                {item.status != "accepted" &&
                  <Button
                    variant="danger"
                    onClick={() => {
                      setModalShow(true);
                      setAcceotRejectId(item?.id);
                      setstatusPending("reject");
                    }}
                  >
                    {currentLocal.home.reject}
                  </Button>
                }
              </div>

              :
              item.status === "rejected" &&
              <div
                className="form-check"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate(`/dashboard/maintenances/edite/${item?.id}`)
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                  />
                </svg>
              </div>
            }
          </td>

          {/* <td>
            {localStorage.getItem("type") !== "maintenance" ? (
              item.status === "rejected" ? (
                <div
                  className="pament bg-success text-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setFeesId(item?.id);
                    setModalShowFees(true);
                  }}
                >
                  {currentLocal.home.rePay}
                </div>
              ) : (
                <div className="d-flex">
  
                  {item.status == "pending" &&
                    <Button
                      variant="danger"
                      onClick={() => {
                        setModalShow(true);
                        setAcceotRejectId(item?.id);
                        setstatusPending("reject");
                      }}
                    >
                      {currentLocal.home.reject}
                    </Button>
                  }
                </div>
              )
            ) : (
              <div
                className="form-check"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate(`/dashboard/maintenances/edite/${item?.id}`)
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                  />
                </svg>
              </div>
            )}
          </td> */}

        </tr>
      )
    })}

  </tbody>

  return (
    <div className="px-0 my-3 w-100 dashboard_content">
      <FeesModel
        show={modalShowFees}
        onHide={() => setModalShowFees(false)}
        feesId={feesId}
      />
      <CustomModel
        show={modalShow}
        onHide={() => setModalShow(false)}
        status={statusPending}
        acceptStatus={'maintenances'}
        id={acceotRejectId}
        is_registration_fee={is_registration_fee}
      />
      <Modal show={showImg} onHide={() => setShowImg(false)} size="lg" centered>
        <Modal.Body className="text-center">
          <img src={imageSrc} alt="full" style={{ width: "100%", height: "auto" }} />
        </Modal.Body>
        <Modal.Footer>
          <a href={imageSrc} download target="_blank" rel="noreferrer">
            <Button variant="primary">{currentLocal.home.download}</Button>
          </a>
          <Button variant="secondary" onClick={() => {
            setImgSrc(false)
            setShowImg(false)
          }}>
            {currentLocal.home.close}
          </Button>
          {/* زر تحميل */}

        </Modal.Footer>
      </Modal>
      <Container>
        <div className="d-flex flex-column w-100">

          <AuthNavbar />
          <div className="mt-5 mx-3">
            <HomeTitle title={currentLocal.home.Maintenance} />

            <p className="w-100 text-start fw-bold"> {currentLocal.home.Totalmaintenanceprice}:{totalPrice} {currentLocal.home.currancy}</p>
            <div className='mb-4 d-flex align-items-center justify-content-between'>
              <div className='d-flex align-items-center'>
                <div className='search'>
                  <input
                    className='px-3 py-1 border- rounded'
                    placeholder={currentLocal.home.search}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                <div>
                  {localStorage.getItem("type") != "maintenance" &&
                    <Button
                      className="mx-3"
                      onClick={() => {
                        setModalShow(true);
                        setAcceotRejectId(selectedIds);
                        setstatusPending("accept");
                      }}
                    >
                      {currentLocal.home.accept}
                    </Button>
                  }
                </div>
              </div>
              <Button
                variant="secondary"
                onClick={() => window.print()}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer-fill" viewBox="0 0 16 16">
                  <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1" />
                  <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                </svg>
              </Button>
            </div>
            {localStorage.getItem("type") == "maintenance" &&
              <ExportBox
                title={""}
                paragrapg={' '}
                addingBtn={currentLocal.home.add + " " + currentLocal.home.Maintenance}
                exportState={false}
              />
            }
            <Table
              data={items}
              headerIterm={headerIterm}
              // onDataChanged={getAllApis}
              actions={localStorage.getItem("type") !== "maintenance" ? ["acceptOrReject"] : ["edit"]}
              acceptStatus={'maintenances'}
              body={body}
              header={header}
            />
            {paginationsItems?.last_page > 1 && (

<Paginations
  total={paginationsItems?.last_page}
  currentPage={currentPage}
  onPageChange={(page) => setCurrentPage(page)}
/>
            )}
          </div>

        </div>
      </Container>
    </div>)
}

export default Maintenance